import axios from "axios";
import io from "socket.io-client";
const socket = io(`${process.env.REACT_APP_CHAT_SERVER}`);

export const CREATE_DEXY_CONVERSATION = "CREATE_DEXY_CONVERSATION";
export const LIST_DEXY_MESSAGES = "LIST_DEXY_MESSAGE_LIST";
export const SET_LOADING = "SET_LOADING";
export const UPDATE_DEXY_MESSAGES = "UPDATE_DEXY_MESSAGES";

export const createDexyConversation = (conversationId) => ({
  type: CREATE_DEXY_CONVERSATION,
  conversationId: conversationId,
});

export const listDexytMessages = (messageList) => ({
  type: LIST_DEXY_MESSAGES,
  messageList: messageList,
});

export const setLoading = (loadingState) => ({
  type: SET_LOADING,
  loadingState: loadingState,
});

export const updateDexyMessages = (message) => ({
  type: UPDATE_DEXY_MESSAGES,
  message: message,
});

export const createBotConversation = () => async (dispatch) => {
  const timestamp = new Date().toISOString().replace(/[^a-zA-Z0-9]/g, ""); // Current timestamp

  const uniqueId = `convo-${timestamp}`;

  try {
    const response = await axios.post(
      `https://chat.botpress.cloud/${process.env.REACT_APP_BOT_PRESS_WEBHOOK_ID}/conversations`,
      {
        id: uniqueId,
      },
      {
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "x-user-key": `${process.env.REACT_APP_BOT_PRESS_X_USER_KEY}`,
        },
      }
    );
    const conversationId = response.data.conversation.id;
    dispatch(createDexyConversation(conversationId));
  } catch (error) {
    console.error("Error:", error);
  }
};

export const sendMessage = (message, conversationId) => async (dispatch) => {
  try {
    const response = await axios.post(
      `https://chat.botpress.cloud/${process.env.REACT_APP_BOT_PRESS_WEBHOOK_ID}/messages`,
      {
        payload: {
          type: "text",
          text: `${message}`,
          from: "Customer",
        },
        conversationId: conversationId,
      },
      {
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "x-user-key": `${process.env.REACT_APP_BOT_PRESS_X_USER_KEY}`,
        },
      }
    );
    console.log("messageResonse:", response.data);
    const messageData = response.data;
    console.log(messageData);
    if (response.status === 200) {
      dispatch(setLoading(true));
    }
  } catch (error) {
    console.error("Error:", error.response ? error.response.data : error);
  }
};

export const updateBotMessages =
  (message, loadingState) => async (dispatch) => {
    if (message) {
      dispatch(updateDexyMessages(message));
      dispatch(setLoading(loadingState));
    }
  };

export const listBotMessages =
  (conversationId, loadingState) => async (dispatch) => {
    dispatch(setLoading(loadingState));
    try {
      const response = await axios.get(
        `https://chat.botpress.cloud/${process.env.REACT_APP_BOT_PRESS_WEBHOOK_ID}/conversations/${conversationId}/messages`,
        {
          headers: {
            accept: "application/json",
            "x-user-key": `${process.env.REACT_APP_BOT_PRESS_X_USER_KEY}`,
          },
        }
      );
      console.log("MessageLisetResponse:", response.data);
      const messageList = response.data;
      dispatch(listDexytMessages(messageList));
      if (response.status === 200) {
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.error("Error:", error);
      dispatch(setLoading(false));
    }
  };
